var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15333 8.32666L11.4867 1.99333C11.94 1.54 11.94 0.806667 11.4867 0.34C11.0333 -0.113333 10.2867 -0.113333 9.83333 0.34L4.32667 5.84667L1.99333 3.51333C1.54 3.06 0.793333 3.06 0.34 3.51333C-0.113333 3.96667 -0.113333 4.7 0.34 5.16667L3.51333 8.32666C3.74 8.55333 4.03333 8.66 4.32667 8.66C4.63333 8.66 4.92667 8.55333 5.15333 8.32666Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenRounded);
export default __webpack_public_path__ + "static/media/check_green_rounded.931c159894251f089dcee465b2fb232c.svg";
export { ForwardRef as ReactComponent };